<template>
  <div class="card-div">
    <div class="card_box">
      <div class="box">
        <div class="title-div">当前电梯基本信息</div>
        <a-row :gutter="[0,0]">
          <a-card class="card-div-class" :bordered="false">
            <a-col :span="24" style=" display: flex;justify-content: center;align-items: center; color: #333333;">
              <a-col :span="24">
                <div>
                  <span class="community-class">{{ addressOrNumm(record.communityName) }}</span>
                  <div class="tag-right-class">
                    <a-tag class="tag-class" v-if="record.insNo" color="green">承保中</a-tag>
                    <a-tag class="tag-class" v-if="!record.insNo">未承保</a-tag>
                  </div>
                </div>
                <div class="build-class">
                  {{ addressOrNumm(record.buildingName) }} {{ addressOrNumm(record.unitName) }} {{ addressOrNumm(record.positionInUnit) }}
                </div>
              </a-col>
            </a-col>
            <a-col :span="24">
              <div class="days-class">
                <span class="days-insurce-class" v-for="(item,index) in insurceDays.toString().split('')" :key="index">{{item}}</span>
                <span class="span-day">天</span>
              </div>
            </a-col>
            <a-col :span="24">
              <a-divider />
            </a-col>
            <a-col :span="24">
              <div class="bot-class">
                <img height="14" src="~@/assets/image/nationalStandard.png" alt=""/>
                <span class="title-policy">设备运行信息展示</span>
              </div>
            </a-col>
          </a-card>
          <a-card class="card-div-class cardDiv" :bordered="false">
            <a-col :span="record.cameraNo || record.dtuNo ? 6 : 8">
              <div class="title-div-class" @click="gotoMiantain">
                <div><img src="~@/assets/new-images/maintain.png"></div>
                <div>维保记录</div>
              </div>
            </a-col>
            <a-col :span="record.cameraNo || record.dtuNo ? 6 : 8">
              <div class="title-div-class" @click="gotoRepair">
                <div><img src="~@/assets/new-images/repair.png"></div>
                <div>维修记录</div>
              </div>
            </a-col>
            <a-col :span="record.cameraNo || record.dtuNo ? 6 : 8">
              <div class="title-div-class" @click="gotoChangeRepair">
                <div><img src="~@/assets/new-images/changerepair.png"></div>
                <div>换件记录</div>
              </div>
            </a-col>
            <a-col :span="6" v-if="record.cameraNo || record.dtuNo">
              <div class="title-div-class" @click="gotoMonitor">
                <div><img src="~@/assets/new-images/tectest.png"></div>
                <div>智能监测</div>
              </div>
            </a-col>
          </a-card>
          <a-card class="card-div-class cardDiv" :bordered="false">
            <div class="titleDiv">电梯信息</div>
            <div class="m-list">
              <div class="m-list-col">
                <a-row :gutter="[0, 10]">
                  <a-col :span="24">
                    <div class="m-list-con">
                      <div class="div1">
                        电梯编号
                      </div>
                      <div class="div2">
                        {{ record.no }}
                      </div>
                    </div>
                  </a-col>
                  <a-col :span="24">
                    <div class="m-list-con">
                      <div class="div1">电梯类型</div>
                      <div class="div2">
                        <span v-if=" record.type == 3100">曳引与强制驱动电梯</span>
                        <span v-if=" record.type == 3300">自动扶梯与自动人行道</span>
                      </div>
                    </div>
                  </a-col>
                  <a-col :span="24">
                    <div class="m-list-con">
                      <div class="div1">注册代码</div>
                      <div class="div2">
                        {{ record.registerNo ? record.registerNo : '-' }}
                      </div>
                    </div>
                  </a-col>
                  <a-col :span="24">
                    <div class="m-list-con">
                      <div class="div1">电梯品牌</div>
                      <div class="div2">
                        {{ record.brand ? record.brand : '-' }}
                      </div>
                    </div>
                  </a-col>
                  <a-col :span="24">
                    <div class="m-list-con">
                      <div class="div1">电梯梯龄</div>
                      <div class="div2">
                        {{ record.beginUseTime ? $moment().diff($moment(record.beginUseTime),'years')+'年' :'-' }}
                      </div>
                    </div>
                  </a-col>
                </a-row>
              </div>
            </div>
          </a-card>
          <a-card class="card-div-class cardDiv" :bordered="false">
            <div class="titleDiv">管理单位</div>
            <div class="m-list">
              <div class="m-list-col">
                <a-row :gutter="[0, 10]">
                  <a-col :span="24">
                    <div class="m-list-con">
                      <div class="div1">
                        使用单位
                      </div>
                      <div class="div2">
                        {{ record.userUnit ? record.userUnit : '-' }}
                      </div>
                    </div>
                  </a-col>
                  <a-col :span="24">
                    <div class="m-list-con">
                      <div class="div1">
                        物业单位
                      </div>
                      <div class="div2">
                        {{ record.userOrgName ? record.userOrgName : '-' }}
                      </div>
                    </div>
                  </a-col>
                  <a-col :span="24">
                    <div class="m-list-con">
                      <div class="div1">
                        安全管理员
                      </div>
                      <div class="div2" v-if="record.followerNames && record.followerNames.length > 0">
                        <span v-for="(followerName,index) in record.followerNames" :key="index">{{followerName}}<span v-if="index < record.followerNames.length-1">、</span></span>
                      </div>
                      <div class="div2" v-else>-</div>
                    </div>
                  </a-col>
                  <a-col :span="24">
                    <div class="m-list-con">
                      <div class="div1">
                        维保单位
                      </div>
                      <div class="div2">
                        {{ record.maintainerOrgName ? record.maintainerOrgName : '-' }}
                      </div>
                    </div>
                  </a-col>
                  <a-col :span="24">
                    <div class="m-list-con">
                      <div class="div1">
                        维保人员
                      </div>
                      <div class="div2" v-if="record.maintainerNames && record.maintainerNames.length > 0">
                        <span v-for="(maintainerName,index) in record.maintainerNames" :key="maintainerName">{{maintainerName}}<span v-if="index < record.maintainerNames.length-1">、</span></span>
                      </div>
                      <div class="div2" v-else>-</div>
                    </div>
                  </a-col>
                </a-row>
              </div>
            </div>
          </a-card>
        </a-row>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import * as echarts from 'echarts'
export default {
  components: {},
  data() {
    return {
      record: {},
      insurceDays:'0000',
    };
  },
  created() {
    let city_id = this.$route.query.city_id ? this.$route.query.city_id : null;
    //新码
    if (this.$route.query.nr_elevator_no) {
      this.getelevatorByNo(this.$route.query.nr_elevator_no, city_id);
    } else if (this.$route.query.nr_elevator_no_o) {
      //老码
      let nr_elevator_no_o = this.$route.query.nr_elevator_no_o;
      this.getelevatorByNo(nr_elevator_no_o.slice(10, 16), city_id);
    }
  },
  methods: {
    gotoMonitor(){
      this.$router.push({ path: 'monitor', query: { record: JSON.stringify(this.record) } });
    },
    gotoMiantain(){
      this.$router.push({ path: 'maintainRecord', query: { record: JSON.stringify(this.record) } });
    },
    gotoRepair(){
      this.$router.push({ path: 'repairRecord', query: { record: JSON.stringify(this.record) } });
    },
    gotoChangeRepair(){
      this.$router.push({ path: 'changerepairRecord', query: { record: JSON.stringify(this.record) } });
    },
    getelevatorByNo(no, city_id) {
      let params = {
        no: no,
        cityId: city_id
      }
      axios.get(site.apiHost + "/elevator-public/elev/get-by-no", { params }).then(res => {
        if (res.data.errorCode == 0) {
          let data = res.data.data
          this.record = data;
          if (data.protectedDays){
            this.insurceDays = this.record.protectedDays
            let index = this.insurceDays.toString().length
            let insurceDays = this.insurceDays+''
            if (index<4){
              for (let j=0;j<4-index;j++){
                insurceDays = '0'+insurceDays
              }
              this.insurceDays = insurceDays
            }
          }
        } else {
          this.$message.error("获取信息失败！");
        }
      }).catch(error => {}).finally(()=>{

      })
    },
    addressOrNumm(value){
      if (value) {
        return value
      } else {
        return ''
      }
    },
  }
};
</script>

<style lang="less" scoped>
body html {
  background-color: #999;
}
.title-div{
  color: white;
  font-size: 20px;
  padding: 10px 0px;
  cursor: pointer;
  text-align: center;
  font-weight: bold;
}
.community-class{
  font-size: 18px;
  font-weight: 500;
}
.tag-right-class{
  float: right;
}
.tag-class{
  border-radius: 50px;
  padding: 0 20px;
}
.build-class{
  font-size: 18px;
  font-weight: 500;
  padding-top: 5px;
}
.days-class{
  font-size: 40px;
  font-weight: bold;
  padding-top: 15px;
  text-align: center;
  .span-day{
    font-weight: 400;
    font-size: 16px;
    vertical-align: bottom;
  }
}
.days-insurce-class{
  margin-right: 5px;
  padding: 0px 10px;
  background-image: url('~@/assets/imgs/border.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: inline-block;
  align-items: center;
  justify-content: center;
  font-size: 42px;
  font-weight: bold;
  color: #333333;
  font-family: PingFangSC, PingFang SC;
}
.bot-class{
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.title-policy{
  font-weight: 500;
  font-size: 14px;
  margin-left: 16px;
  font-weight: bold;
  color: #333333;
}
.value-num{
  font-size: 25px;
  font-weight: bold;
  color: #333333;
}
.card-div {
  box-sizing: border-box;
  .card_box {
    height: 120px;
    background-color: #ff4d4f;
    position: relative;
    .box {
      width: 100%;
      position: absolute;
      top: 0;
      padding: 16px;
      .card-div-class {
        background-color: white;
        border-radius: 10px;
        padding: 16px;
        overflow: hidden;
        font-family: Microsoft Yahei;
        margin-top: 10px;
      }
      .cardDiv {
        margin-top: 16px;
        .titleDiv {
          font-size: 18px;
          font-weight: bold;
          color: #333333;
          padding-bottom: 10px;
        }
        .cardBorder {
          padding-left: 10px;
          font-size: 14px;
        }
        .cardBorder2 {
          padding-left:20px;
          font-size: 14px;
        }
        .cardBorder::after {
          content: "";
          position: absolute;
          right: 15px;
          top: 2px;
          width: 1px;
          background-color: #dddddd;
          height: 90%;
        }
        .onYear {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .sort-value1 {
            color: #52c41a;
          }
          .sort-value2 {
            color: #ff4d4f;
          }
          .sort-value3 {
            color: #ff6600;
          }
        }
      }
    }
  }
}
/deep/.ant-card-body {
  padding: 0px;
  font-size: 16px !important;
  color: #333333;
}
/deep/.ant-col {
  padding: 0px !important;
}

/deep/ .ant-divider-horizontal {
  display: block;
  clear: both;
  width: 100%;
  min-width: 100%;
  height: 1px;
  margin: 10px 0;
}
#gaugeEcharts {
  width: 100%;
  height: 220px;
  margin: 0 auto;
  border-bottom: 1px solid #F2F2f7;
}

/* 超出容器大小的文本以省略号表示 */
.health-class {
  height: 85px;
  width: 100%;
  border-bottom: 1px solid #F2F2f7;
  padding: 10px 0px 0px 0px;
}

.health-title {
  font-size: 14px;
  font-family: PingFangSC, PingFang SC;
  color: #333333;
}

.health-vlaue {
  font-size: 30px;
  font-family: PingFangSC, PingFang SC;
  font-weight: bold;
  color: #333333;
  float: left;
}

.health-vlaue-houer {
  font-size: 13px;
  font-family: PingFangSC, PingFang SC;
  font-weight: bold;
  color: #333333;
}

.sort-class1 {
  font-size: 24px;
  font-weight: bold;
  padding-left: 10px;
  font-family: PingFangSC, PingFang SC;
  color: #70B603;
}

.sort-class2 {
  font-size: 24px;
  font-weight: bold;
  padding-left: 10px;
  font-family: PingFangSC, PingFang SC;
  color: #FF4D4F;
}

.sort-class3 {
  font-size: 24px;
  font-weight: bold;
  padding-left: 10px;
  font-family: PingFangSC, PingFang SC;
  color: #F59A23;
}

.health-vlaue-time {
  font-size: 13px;
  font-family: PingFangSC, PingFang SC;
  color: #333333;
  float: left;
  white-space: pre-wrap;
  width: 60%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* 定义文本的行数 */
  overflow: hidden;
  text-overflow: ellipsis;
}

.health-value1 {
  font-size: 13px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #999999;
}

.sort-value1 {
  color: #52c41a;
  padding-left: 6px;
}

.sort-value2 {
  color: #ff4d4f;
  padding-left: 6px;
}

.health-value2 {
  font-size: 13px;
  padding: 2px 0px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #999999;
  text-align: right;
  position: relative;
  top: -22px;
}
#dayslineecharts {
  height: 220px;
}
.a-class{
  text-align: center;
  a{
    color: #ff4d4f;
  }
}
#repairstatic {
  height: 200px;
}
.title-div-class{
  text-align: center;
  cursor: pointer;
  font-size: 14px;
}
.m-list {
  width: 100%;
  height: auto;
}

.m-list-col {
  width: 100%;
}

.m-list-con {
  color: #333333;
  display: flex;
  margin-bottom: 6px;
}
.div1 {
  font-size: 14px;
  font-weight: 400;
  flex-shrink: 0;
  color: #999999;
}
.div2 {
  font-size: 14px;
  font-weight: 400;
  flex: 1;
  padding-left:15px;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/qrCodeInformation.vue